import React from 'react';
import { motion } from 'framer-motion';
import './Projects.css';

const Projects = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="projects-container">
      <motion.div 
        className="projects-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h1>Our Projects</h1>
        <p>Explore our portfolio of successful projects</p>
      </motion.div>

      <div className="projects-grid">
        {/* Project cards will be added here */}
      </div>
    </div>
  );
};

export default Projects; 